module.exports = __webpack_public_path__ + "static/media/zoom-reset-icon.22980c0f.svg";